import styled from 'styled-components';
import { darkgrey, saveButtonBackgroundColor } from 'styles/Colors';

export const ControlsWrapper = styled.div`
  font-size: 15px;
  color: ${darkgrey};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  gap: 0 8px;
  padding: 0px 16px;
  display: flex;
  border-radius: 12px;
  background: #f5f5f5;
  height: 40px;
`;

export const ControlBtn = styled.div`
  font-family: Lato;
  font-style: normal;
  display: flex;
  cursor: pointer;
  align-items: center;
  border-radius: 4px;
  transition: 0.3s;

  &:hover {
    opacity: 0.75;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  }
`;

export const IconWrapper = styled.div`
  background-color: ${saveButtonBackgroundColor};
  border-radius: 4px;
  height: 32px;
  width: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const SettingsLabelContainer = styled.div`
  flex-direction: column;
  display: flex;
  margin-right: 8px;
  align-items: flex-end;
`;

export const BottomLabel = styled.span`
  font-family: Oswald;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: 15px;
  letter-spacing: 0.65px;
  text-transform: uppercase;
`;
